/**
 * @fileoverview POST handler for the "/app_settings/authentication_credential/edit" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appSettingsAuthenticationCredentialEditCacheKeys } from "./constants";
import type {
  PostAppSettingsAuthenticationCredentialEditProps,
  AppSettingsAuthenticationCredentialEditResult,
  AppSettingsAuthenticationCredentialEditResultErrors,
} from "./types";

export const postAppSettingsAuthenticationCredentialEdit = reactQueryMutationAdapter(
  appSettingsAuthenticationCredentialEditCacheKeys,
  createMutationFetcherFunctionWithShadowError<AppSettingsAuthenticationCredentialEditResultErrors>()(
    (
      params: PostAppSettingsAuthenticationCredentialEditProps
    ): Promise<AppSettingsAuthenticationCredentialEditResult> => {
      return fetch("/app_settings/authentication_credential/edit", "POST", params);
    }
  )
);
